import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages.component';
import { LoginComponent } from './login/login.component';
import {AuthGuard} from '../shared/guards/auth.guard';

export const childRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'pages',
        component: PagesComponent, /*canActivateChild: [AuthGuard],*/
        children: [
            { path: '', redirectTo: 'index', pathMatch: 'full' },
            { path: 'index', loadChildren: './index/index.module#IndexModule' },
            {
              path: 'admin', loadChildren: './admin/admin.module#AdminModule',
              canActivate: [AuthGuard],
              data: {roles : ['ADMIN'] }
            },
            { path: 'achat', loadChildren: './achat/achat.module#AchatModule',
              canActivate: [AuthGuard], data: {roles : ['ADMIN', 'AGENT_CENTRE','CHEF_LABORATOIRE']} },
            { path: 'vente', loadChildren: './vente/vente.module#VenteModule',
              canActivate: [AuthGuard], data: {roles : ['ADMIN', 'RESPONSABLE_PAIEMENT', 'AGENT_CENTRE']} },
            { path: 'labo', loadChildren: './laboratoire/laboratoire.module#LaboratoireModule',
              canActivate: [AuthGuard], data: {roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE']} },
            { path: 'stats', loadChildren: './stats/stats.module#StatsModule',
              canActivate: [AuthGuard], data: {roles : ['ADMIN', 'LABORATOIRE_SAISIE', 'CHEF_LABORATOIRE']} }
        ]
    }
];

export const routing = RouterModule.forChild(childRoutes);
